import AbstractConfig from "../../../core/config/AbstractConfig";

export default class TimerConfig extends AbstractConfig {
    constructor() {
        super();
    }
}
